export default __webpack_public_path__ + "static/29_aug_21-d90cf35fefc0301f11ab3af9e4683857.png";